import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default [
  {
    prop: "ProviderCode",
    name: "Codigo",
    label: "Codigo ",
    width: 130,
    sortable: true
  },
  {
    prop: "ProviderName",
    name: "Nombre del Proveedor",
    label: "Nombre del Proveedor",
    minWidth: 420,
    formatter: ImagePerson,
    sortable: true
  },
  //   {
  //     prop: "PEmail",
  //     name: "Email",
  //     label: "Email",
  //     minWidth: 300,
  //     sortable: true
  //   },
  //   {
  //     prop: "PAdress",
  //     name: "Direccion",
  //     label: "Direccion",
  //     width: 150,
  //     sortable: true
  //   },
  //   {
  //     prop: "PCity",
  //     name: "Ciudad",
  //     label: "Ciudad",
  //     width: 130,
  //     sortable: true
  //   },
  //
  {
    prop: "PRnc",
    name: "RNC",
    label: "RNC",
    minWidth: 220,
    sortable: true
  },
  {
    prop: "P_PhoneNo",
    name: "Numero Telefonico",
    label: "Numero Telefonico",
    minWidth: 220,
    sortable: true
  }
  //   {
  //     prop: "PCurrecyC",
  //     name: "Moneda",
  //     label: "Moneda",
  //     minWidth: 220,
  //     sortable: true
  //   },
];
